import React from 'react';
import Select from 'Shared/ui/Select';
import styled from 'styled-components';
import ArrowBottom2 from 'crehana-icons/ArrowBottom2';
import { mainText } from 'aegisv2/styles/colors';
import {
  secondaryMain,
  primaryText,
  primaryMain,
  grayLight,
} from 'crehana-ui/styles/colors';

const SelectStyles = `
  .Select {
    position: relative;
  }
  .Select,
  .Select div,
  .Select input,
  .Select span {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  .Select.is-disabled > .Select-control {
    background-color: #f9f9f9;
  }
  .Select.is-disabled > .Select-control:hover {
    box-shadow: none;
  }
  .Select.is-disabled .Select-arrow-zone {
    cursor: default;
    pointer-events: none;
    opacity: 0.35;
  }
  .Select-control {
    background-color: #FAFAFA;
    border-radius: 5px;
    color: #333;
    cursor: default;
    display: table;
    border-spacing: 0;
    border-collapse: separate;
    height: 36px;
    outline: none;
    overflow: hidden;
    position: relative;
    width: 100%;
    @media (max-width: 1139px) {
      background-color: unset;
    }
  }
  .Select-control:hover {

  }
  .Select-control .Select-input:focus {
    outline: none;
  }
  .is-searchable.is-open > .Select-control {
    cursor: text;
  }
  .is-open > .Select-control {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .is-open > .Select-control .Select-arrow {
    top: -2px;
    border-color: transparent transparent #999;
    border-width: 0 5px 5px;
  }
  .is-searchable.is-focused:not(.is-open) > .Select-control {
    cursor: text;
  }
  .is-focused:not(.is-open) > .Select-control {

  }
  .Select-placeholder,
  .Select--single > .Select-control .Select-value {
    cursor: pointer;
    bottom: 0;
    color: #aaa;
    left: 0;
    line-height: 48px;
    padding-left: 12px;
    padding-right: 12px;
    position: absolute;
    right: 0;
    top: 0;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    @media (max-width: 414px) {
      padding-left: 0px;
      padding-right: 18px;
    }
  }
  .has-value.is-clearable.Select--single > .Select-control .Select-value {
    padding-right: 42px;
  }
  .has-value.Select--single > .Select-control .Select-value .Select-value-label,
  .has-value.is-pseudo-focused.Select--single
    > .Select-control
    .Select-value
    .Select-value-label {
    color: ${secondaryMain};
    font-family: Nunito, Arial, sans-serif;
    @media (max-width: 1139px) {
      font-family: Gilroy, Arial, sans-serif;
      font-weight: 700;
      font-size: 16px;
      color: ${primaryText};
    }
    @media (max-width: 320px) {
      font-size: 14px;
    }
  }
  .has-value.Select--single
    > .Select-control
    .Select-value
    a.Select-value-label,
  .has-value.is-pseudo-focused.Select--single
    > .Select-control
    .Select-value
    a.Select-value-label {
    cursor: pointer;
    text-decoration: none;
  }
  .has-value.Select--single
    > .Select-control
    .Select-value
    a.Select-value-label:hover,
  .has-value.is-pseudo-focused.Select--single
    > .Select-control
    .Select-value
    a.Select-value-label:hover,
  .has-value.Select--single
    > .Select-control
    .Select-value
    a.Select-value-label:focus,
  .has-value.is-pseudo-focused.Select--single
    > .Select-control
    .Select-value
    a.Select-value-label:focus {
    color: #007eff;
    outline: none;
    text-decoration: underline;
  }
  .Select-input {
    height: 48px;
    padding-left: 12px;
    padding-right: 12px;
    vertical-align: middle;
  }
  .Select-input > input {
    width: 100%;
    background: none transparent;
    border: 0 none;
    box-shadow: none;
    cursor: default;
    display: inline-block;
    font-family: inherit;
    font-size: inherit;
    margin: 0;
    outline: none;
    line-height: 14px;
    /* For IE 8 compatibility */
    padding: 8px 0 12px;
    /* For IE 8 compatibility */
    -webkit-appearance: none;
  }
  .is-focused .Select-input > input {
    cursor: text;
  }
  .has-value.is-pseudo-focused .Select-input {
    opacity: 0;
  }
  .Select-control:not(.is-searchable) > .Select-input {
    outline: none;
  }
  .Select-loading-zone {
    cursor: pointer;
    display: table-cell;
    position: relative;
    text-align: center;
    vertical-align: middle;
    width: 16px;
  }
  .Select-loading {
    -webkit-animation: Select-animation-spin 400ms infinite linear;
    -o-animation: Select-animation-spin 400ms infinite linear;
    animation: Select-animation-spin 400ms infinite linear;
    width: 16px;
    height: 16px;
    box-sizing: border-box;
    border-radius: 50%;
    border: 2px solid #ccc;
    border-right-color: #333;
    display: inline-block;
    position: relative;
    vertical-align: middle;
  }
  .Select-clear-zone {
    -webkit-animation: Select-animation-fadeIn 200ms;
    -o-animation: Select-animation-fadeIn 200ms;
    animation: Select-animation-fadeIn 200ms;
    color: #999;
    cursor: pointer;
    display: table-cell;
    position: relative;
    text-align: center;
    vertical-align: middle;
    width: 17px;
  }
  .Select-clear-zone:hover {
    color: #d0021b;
  }
  .Select-clear {
    display: inline-block;
    font-size: 18px;
    line-height: 1;
  }
  .Select--multi .Select-clear-zone {
    width: 17px;
  }
  .Select-arrow-zone {
    cursor: pointer;
    display: table-cell;
    position: relative;
    text-align: center;
    vertical-align: middle;
    width: 25px;
    padding-right: 12px;
    svg {
      margin-right: 0;
    }
    @media (max-width: 414px){
      padding-right: 22px;
    }
  }
  .Select-arrow {
    border-color: #999 transparent transparent;
    border-style: solid;
    border-width: 5px 5px 2.5px;
    display: inline-block;
    height: 0;
    width: 0;
    position: relative;
  }
  .is-open .Select-arrow,
  .Select-arrow-zone:hover > .Select-arrow {
    border-top-color: ${mainText};
  }
  .Select--multi .Select-multi-value-wrapper {
    display: inline-block;
  }
  .Select .Select-aria-only {
    display: inline-block;
    height: 1px;
    width: 1px;
    margin: 0px;
    clip: rect(0, 0, 0, 0);
    overflow: hidden;
    float: left;
  }
  @-webkit-keyframes Select-animation-fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @keyframes Select-animation-fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  .Select-menu-outer {
    background-color: #fff;
    box-sizing: border-box;
    margin-top: 0px;
    max-height: 200px;
    position: absolute;
    top: 100%;
    width: 100%;
    z-index: 1;
    -webkit-overflow-scrolling: touch;
    @media (max-width: 1139px){
      border: 1px solid ${grayLight};
    }
    @media (max-width: 414px){
      width: 100vw;
      left:-2px;
      transform:translateX(-50%);
    }
  }
  .Select-menu {
    max-height: 198px;
    overflow-y: auto;
  }
  .Select-option {
    box-sizing: border-box;
    background-color: #FAFAFA;
    color: ${mainText};
    font-size: 13.86px;
    cursor: pointer;
    display: block;
    padding: 8px 12px;
    @media (max-width: 1139px){
      font-family: Nunito, Arial, sans-serif;
      font-weight: 700;
      font-size: 16px;
      background-color: unset;
      border-bottom: 1px solid ${grayLight};
      padding: 16px;
      display: flex;
      justify-content: flex-start;
    }
  }
  .Select-option:last-child {
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  .Select-option.is-selected {
    color: ${mainText} !important;
  }
  .Select-option.is-focused {
    background-color: rgba(0, 153, 255, 0.1);
    color: ${mainText};
  }
  .Select-option.is-disabled {
    color: #cccccc;
    cursor: default;
  }
  .Select-noresults {
    box-sizing: border-box;
    color: #999999;
    cursor: default;
    display: block;
    padding: 8px 12px;
  }
  .Select--multi .Select-input {
    vertical-align: middle;
    margin-left: 10px;
    padding: 0;
  }
  .Select--multi.has-value .Select-input {
    margin-left: 5px;
  }
  .Select--multi .Select-value {
    background-color: #ebf5ff;
    /* Fallback color for IE 8 */
    background-color: rgba(0, 126, 255, 0.08);
    border-radius: 2px;
    border: 1px solid #c2e0ff;
    /* Fallback color for IE 8 */
    border: 1px solid rgba(0, 126, 255, 0.24);
    color: #007eff;
    display: inline-block;
    font-size: 0.9em;
    line-height: 1.4;
    margin-left: 5px;
    margin-top: 5px;
    vertical-align: top;
  }
  .Select--multi .Select-value-icon,
  .Select--multi .Select-value-label {
    display: inline-block;
    vertical-align: middle;
  }
  .Select--multi .Select-value-label {
    border-bottom-right-radius: 2px;
    border-top-right-radius: 2px;
    cursor: default;
    padding: 2px 5px;
  }
  .Select--multi a.Select-value-label {
    color: #007eff;
    cursor: pointer;
    text-decoration: none;
  }
  .Select--multi a.Select-value-label:hover {
    text-decoration: underline;
  }
  .Select--multi .Select-value-icon {
    cursor: pointer;
    border-bottom-left-radius: 2px;
    border-top-left-radius: 2px;
    border-right: 1px solid #c2e0ff;
    /* Fallback color for IE 8 */
    border-right: 1px solid rgba(0, 126, 255, 0.24);
    padding: 1px 5px 3px;
  }
  .Select--multi .Select-value-icon:hover,
  .Select--multi .Select-value-icon:focus {
    background-color: #d8eafd;
    /* Fallback color for IE 8 */
    background-color: rgba(0, 113, 230, 0.08);
    color: #0071e6;
  }
  .Select--multi .Select-value-icon:active {
    background-color: #c2e0ff;
    /* Fallback color for IE 8 */
    background-color: rgba(0, 126, 255, 0.24);
  }
  .Select--multi.is-disabled .Select-value {
    background-color: #fcfcfc;
    border: 1px solid #e3e3e3;
    color: #333;
  }
  .Select--multi.is-disabled .Select-value-icon {
    cursor: not-allowed;
    border-right: 1px solid #e3e3e3;
  }
  .Select--multi.is-disabled .Select-value-icon:hover,
  .Select--multi.is-disabled .Select-value-icon:focus,
  .Select--multi.is-disabled .Select-value-icon:active {
    background-color: #fcfcfc;
  }
  @keyframes Select-animation-spin {
    to {
      transform: rotate(1turn);
    }
  }
  @-webkit-keyframes Select-animation-spin {
    to {
      -webkit-transform: rotate(1turn);
    }
  }
`;

const Wrapper = styled.div`
  ${SelectStyles};
`;

const StyledSelect = styled(Select)`
  font: 14px Nunito, Arial, sans-serif;
  border-radius: 5px;
  border: none;
  background-color: #ffffff;

  flex: 1;
  z-index: 5;
  box-shadow: none !important;
  & .Select-control {
    border: none;
    height: 48px;
    .Select-value {
      line-height: 48px;
      padding-left: 12px;
      padding-right: 10px;
    }
  }
  & .Select-menu-outer {
    max-height: 510px !important;
  }
  & .Select-menu {
    max-height: 508px !important;
  }
`;

const ArrowWrapper = styled.div`
  transition: transform 0.3s ease-in-out;
  ${props => {
    if (props.isOpen) {
      return `
        transform: rotateZ(180deg)
      `;
    }
    return `
      transform: rotateZ(0deg);
    `;
  }}
`;

const DesktopWrapper = styled.div`
  display: block;
  @media (max-width: 1139px) {
    display: none;
  }
`;

const MobileWrapper = styled.div`
  display: none;
  @media (max-width: 1139px) {
    display: block;
  }
`;

const RenderArrow = ({ isOpen }) => (
  <ArrowWrapper isOpen={isOpen}>
    <DesktopWrapper>
      <ArrowBottom2 size={8} color={mainText} />
    </DesktopWrapper>
    <MobileWrapper>
      <ArrowBottom2 size={8} color={primaryMain} />
    </MobileWrapper>
  </ArrowWrapper>
);

export default props => (
  <Wrapper>
    <StyledSelect
      {...props}
      instanceId="catalog-select"
      arrowRenderer={RenderArrow}
    />
  </Wrapper>
);
